export default "__VITE_ASSET__DJ1GcVjm__"